import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {useHistory, useLocation} from 'react-router-dom'
import {ITabs} from 'src/app/components/Widgets/Tabs/Tabs'
import {usePaginationQuery} from 'src/app/hooks/list-table-query.hook'
import {useWebTitle} from 'src/app/hooks/title.hook'
import {IApproval, IApprovalQuery} from 'src/app/models/Job/Approval.model'
import {
  getListWaitApprovalJob,
  getTotalApproval,
  LIST_WAIT_APPROVAL_KEY,
  TOTAL_APPROVAL_KEY,
} from 'src/app/services/Job/Approval.services'
import JobRedux from 'src/app/store/Job/JobRedux'
import {filterTableArray, formatFilterDate} from 'src/app/utils/format.utils'
import {useErrorQuery} from '../../../hooks/error-query.hook'
import JobScreens from '../routes/Screen'
import {formFilterJob} from './form-job-template.hook'
import {useTableApproval} from './table-approval.hook'

export const useListApproval = (page: 'WAITING' | 'DONE') => {
  useWebTitle(
    page === 'WAITING'
      ? JobScreens.PERSETUJUAN_TUGAS_LIST_WAITING.TITLE
      : JobScreens.PERSETUJUAN_TUGAS_LIST_DONE.TITLE
  )
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()

  const applyFilters = (params: IApprovalQuery) => {
    return {
      ...params,
      priorities: filterTableArray(params.priorities as string[]),
      statuses: page === 'DONE' ? filterTableArray(['REJECTED', 'CLOSED']) : undefined,
      start_date: params.start_date ? formatFilterDate(params.start_date, 'START') : undefined,
      end_date: params.end_date ? formatFilterDate(params.end_date, 'END') : undefined,
    }
  }

  const renderTable = usePaginationQuery<IApproval[], IApprovalQuery>({
    queryKey: [LIST_WAIT_APPROVAL_KEY, page],
    queryFn: (params) => {
      return getListWaitApprovalJob(applyFilters(params))
    },
    filterForm: formFilterJob,
    screen: JobScreens.JOB_TUGAS.TITLE,
  })

  const {
    isEmptyTable,
    state,
    isError,
    isInitialLoading,
    searchFn,
    resetFilterFn,
    isShow,
    setIsShow,
    filterCount,
    formik,
    refetch,
  } = renderTable

  const {
    headers,
    deleteModal,
    setDeleteModal,
    selected,
    formFilter,
    rejectModal,
    setRejectModal,
    approveModal,
    setApproveModal,
  } = useTableApproval(state, formik, page)

  const tabList: ITabs[] = [
    {
      active: location.pathname === JobScreens.PERSETUJUAN_TUGAS_LIST_WAITING.PATH,
      title: 'Butuh Persetujuan',
      onClick: () => history.push(JobScreens.PERSETUJUAN_TUGAS_LIST_WAITING.PATH),
    },
    {
      active: location.pathname === JobScreens.PERSETUJUAN_TUGAS_LIST_DONE.PATH,
      title: 'Selesai',
      onClick: () => history.push(JobScreens.PERSETUJUAN_TUGAS_LIST_DONE.PATH),
    },
  ]

  useEffect(() => {
    dispatch(JobRedux.actions.setResetForm())
  }, [dispatch])

  return {
    tabList,
    isError,
    isEmptyTable,
    isInitialLoading,
    renderTable,
    state,
    searchFn,
    isShow,
    setIsShow,
    filterCount,
    formik,
    resetFilterFn,
    headers,
    deleteModal,
    setDeleteModal,
    selected,
    formFilter,
    history,
    refetch,
    rejectModal,
    setRejectModal,
    approveModal,
    setApproveModal,
  }
}

export const useTotalApproval = (queryOptions?: Partial<UseQueryOptions>) => {
  const {errorTemp} = useErrorQuery()

  return useQuery({
    queryKey: [TOTAL_APPROVAL_KEY],

    queryFn: async () => {
      const payload = await getTotalApproval()
      return payload.data.response_output?.detail
    },
    onError: (e) => errorTemp(e),
    ...queryOptions,
  })
}
